type Options = {
	trim?: boolean;
	dropEmptyArrayItems?: boolean;
};

export function normalizeEmptyStringsToNull<T>(
	value: T,
	opts: Options = { trim: true, dropEmptyArrayItems: true },
): T {
	const { trim = true, dropEmptyArrayItems = true } = opts;

	if (value === null || value === undefined) return value;

	if (typeof value === "string") {
		const v = trim ? value.trim() : value;
		return v === "" ? (null as unknown as T) : (v as unknown as T);
	}

	if (Array.isArray(value)) {
		const mapped = value.map((v) => normalizeEmptyStringsToNull(v, opts));
		if (dropEmptyArrayItems) {
			return mapped.filter(
				(v) => v !== null && v !== undefined,
			) as unknown as T;
		}
		return mapped as unknown as T;
	}

	if (typeof value === "object") {
		const out: Record<string, unknown> = {};
		for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
			out[k] = normalizeEmptyStringsToNull(v, opts);
		}
		return out as T;
	}

	return value;
}

export function normalizeIpAddress(ip: string) {
	if (ip.trim() === "") {
		return "";
	}
	if (ip.includes("://")) {
		return ip;
	}
	return `http://${ip}`;
}
